var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6173 0.158513C19.8623 0.0570186 20.1377 0.0570187 20.3827 0.158513L33.7595 5.69935C34.0045 5.80085 34.1992 5.99552 34.3006 6.24055L39.8415 19.6173C39.943 19.8623 39.943 20.1377 39.8415 20.3827L34.3006 33.7595C34.1992 34.0045 34.0045 34.1992 33.7595 34.3006L20.3827 39.8415C20.1377 39.943 19.8623 39.943 19.6173 39.8415L6.24055 34.3006C5.99552 34.1992 5.80085 34.0045 5.69935 33.7595L0.158513 20.3827C0.0570186 20.1377 0.0570187 19.8623 0.158513 19.6173L5.69935 6.24055C5.80085 5.99552 5.99552 5.80085 6.24055 5.69935L19.6173 0.158513Z",
    fill: "#FF7F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4577 24.0521L12.5059 20.1003L12.5059 20.1003C11.8182 19.4128 10.7034 19.4128 10.0157 20.1003L10.0156 20.1004C9.32813 20.7881 9.32813 21.9029 10.0156 22.5906L10.0157 22.5907L14.5905 27.1638C14.5905 27.1638 14.5906 27.1638 14.5906 27.1638C15.0855 27.6595 15.7572 27.9379 16.4577 27.9377M16.4577 24.0521L18.3245 27.1641C17.8296 27.6596 17.158 27.9379 16.4577 27.9377M16.4577 24.0521L27.4941 13.0157L27.4941 13.0156C28.1818 12.3281 29.2966 12.3281 29.9843 13.0156L29.9844 13.0157C30.6719 13.7034 30.6719 14.8182 29.9844 15.5059L29.9843 15.5059L18.3248 27.1638L16.4577 24.0521ZM16.4577 27.9377C16.4576 27.9377 16.4575 27.9377 16.4574 27.9377L16.4577 27.4377L16.4579 27.9377C16.4578 27.9377 16.4577 27.9377 16.4577 27.9377Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeVerify);
export default __webpack_public_path__ + "static/media/badgeVerify.9fc3ae9f7937fd76f9003f55b011cbdf.svg";
export { ForwardRef as ReactComponent };